// extracted by mini-css-extract-plugin
export default {"systemInfo":"SystemInfo_systemInfo__wxxxZ"};